import { Badge } from '@app/components/badge';
import { T } from '@app/components/translation';

import style from './badge-legacy.module.scss';

// Note: This is an actual "Legacy" badge, it's not a legacy implementation of the Badge component
export const BadgeLegacy = () => (
  <Badge className={style.BadgeLegacy}>
    <T
      _str="Legacy"
      _comment="Legacy badge label"
    />
  </Badge>
);
